import { userActionTypes } from './../constants/ApiConstants';
// import GlobalVariables from '../../../actions/utilAction';

const initialState = {
  appointments_list: [],
  loading: false,
  appointment_created: false,
  master_data: [],
  patients: [],
  appointment_deleted: false,
  users_list: [],
  staffs_list: null,
  staffs_list_ByTags: null,
  clients_list_ByTags: null,
  staffProfileDetails: null,
  deleted_user: null,
  saved_availibility_template: {},
  get_availability_template_by_id: null,
  masterCustomLabelStaff: null,
  saved_customLabelValues: null,
  get_master_tags: [],
  staffActiveStatus: false,
  staffLockStatus: false,
  userMenuShowStatus: false,
  getOfficeHours: null,
  saved_StaffDetails: null,
  staffDetails: null,
  applied_leave_list: null,
  applied_Leave_list_by_id: null,
  post_apply_leave: null,
  applied_leave_deleted: {},
  update_status: null,
  staff_time_sheet_data: null,
  update_time_sheet: null,
  time_sheet_table_data: null,
  staffsAndPatientsByLocation: null,
  save_user_time_sheet_data: null,
  user_time_sheet_data_by_id: null,
  delete_user_time_sheet_data: null,
  submit_time_sheet_status: null,
  staffPayrollRates: null,
  saved_staffPayrollRates: null,
  staffLocationsList: null,
  patientList: [],
  saved_Notes: null,
  deleted_Notes: null,
  staffTrainingTitleHours: null,
  saved_staffTrainingTitleHours: null,
  userRoles: null,
  appointmentTypeList: [],
  reset_User_Email:null,
  check_Email_Validation:null,
  responseMessage : null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case userActionTypes.get_appointments.REQUEST:
  case userActionTypes.save_appointment.REQUEST:
  case userActionTypes.get_user_locations.REQUEST:
  case userActionTypes.get_staff_locations.REQUEST:
  case userActionTypes.search_patient.REQUEST:
  case userActionTypes.delete_appointment.REQUEST:
  case userActionTypes.get_appointment_by_id.REQUEST:
  case userActionTypes.get_master_state_by_countryid.REQUEST:
  case userActionTypes.delete_user.REQUEST:
  case userActionTypes.get_users_by_size.REQUEST:
  case userActionTypes.get_all_users.REQUEST:
  case userActionTypes.get_users_by_location.REQUEST:
  case userActionTypes.post_user_tag.REQUEST:
  case userActionTypes.save_availibility_template.REQUEST:
  case userActionTypes.patch_staff_active_status.REQUEST:
  case userActionTypes.patch_staff_lock_status.REQUEST:
  case userActionTypes.save_user.REQUEST:
  case userActionTypes.get_user_by_id.REQUEST:
  case userActionTypes.patch_staff_scheduler_lock.REQUEST:
    return {
      ...state,
      master_data: state.master_data,
      loading: true,
    };
  case userActionTypes.get_staff_time_sheet_table_view.REQUEST:
    return {
      ...state,
      loading: true,
      time_sheet_table_data: null,
    };
  case userActionTypes.get_staff_time_sheet_table_view.SUCCESS:
    return {
      ...state,
      loading: false,
      time_sheet_table_data: payload,
    };
  case userActionTypes.update_leave_status.REQUEST:
    return {
      ...state,
      loading: true,
      update_status: null,
    };
  case userActionTypes.update_leave_status.SUCCESS:
    return {
      ...state,
      loading: false,
      update_status: payload,
    };
  case userActionTypes.post_staff_leave.REQUEST:
    return {
      ...state,
      loading: true,
      post_apply_leave: null,
    };
  case userActionTypes.post_staff_leave.SUCCESS:
    return {
      ...state,
      loading: false,
      post_apply_leave: payload,
    };
  case userActionTypes.delete_applied_leave.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case userActionTypes.delete_applied_leave.SUCCESS:
    return {
      ...state,
      loading: false,
      applied_leave_deleted: payload,
    };
  case userActionTypes.update_staff_time_sheet.REQUEST:
    return {
      ...state,
      loading: true,
      update_time_sheet: null,
    };
  case userActionTypes.update_staff_time_sheet.SUCCESS:
    return {
      ...state,
      loading: false,
      update_time_sheet: payload,
    };
  case userActionTypes.update_staff_time_sheet.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case userActionTypes.get_staff_time_sheet.REQUEST:
    return {
      ...state,
      loading: true,
      staff_time_sheet_data: null,
    };
  case userActionTypes.submit_timesheet_status.REQUEST:
    return {
      ...state,
      loading: true,
      submit_time_sheet_status: null,
    };
  case userActionTypes.submit_timesheet_status.SUCCESS:
    return {
      ...state,
      loading: false,
      submit_time_sheet_status: payload,
    };
  case userActionTypes.submit_timesheet_status.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case userActionTypes.get_staff_time_sheet.SUCCESS:
    return {
      ...state,
      loading: false,
      staff_time_sheet_data: payload,
    };
  case userActionTypes.get_applied_leave_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      applied_Leave_list_by_id: null,
    };
  case userActionTypes.get_applied_leave_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      applied_Leave_list_by_id: payload,
    };
  case userActionTypes.delete_user_time_sheet.REQUEST:
    return {
      ...state,
      loading: true,
      delete_user_time_sheet_data: null,
    };
  case userActionTypes.delete_user_time_sheet.SUCCESS:
    return {
      ...state,
      loading: false,
      delete_user_time_sheet_data: payload,
    };
  case userActionTypes.get_appointments.SUCCESS:
    return {
      ...state,
      loading: false,
      appointments_list: payload,
    };
  case userActionTypes.get_appointment_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      appointment: payload,
    };

  case userActionTypes.get_user_locations.SUCCESS:
    let locationId = 0;
    payload.map((Obj) => {
      if (Obj.IsDefault) {
        locationId = Obj.LocationID;
      }
      return locationId;
    });
    return {
      ...state,
      loading: false,
      userLocations: payload,
      currentLocationId: locationId,
    };
  case userActionTypes.get_staff_locations.SUCCESS:
    return {
      ...state,
      loading: false,
      staffLocations: payload,
    };
  case userActionTypes.post_staffCustomValues.REQUEST:
    return {
      ...state,
      loading: true,
      saved_customLabelValues: null,
    };
  case userActionTypes.post_staffCustomValues.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_customLabelValues: payload,
    };
  case userActionTypes.get_user_time_sheet_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      user_time_sheet_data_by_id: null,
    };
  case userActionTypes.get_user_time_sheet_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      user_time_sheet_data_by_id: payload,
    };
  case userActionTypes.save_user_time_sheet_details.REQUEST:
    return {
      ...state,
      loading: true,
      save_user_time_sheet_data: null,
    };
  case userActionTypes.save_user_time_sheet_details.SUCCESS:
    return {
      ...state,
      loading: false,
      save_user_time_sheet_data: payload,
    };
  case userActionTypes.save_user_time_sheet_details.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case userActionTypes.get_staff_and_patient_bylocation.REQUEST:
    return {
      ...state,
      loading: true,
      staffsAndPatientsByLocation: null,
    };
  case userActionTypes.get_staff_and_patient_bylocation.SUCCESS:
    return {
      ...state,
      loading: false,
      staffsAndPatientsByLocation: payload,
    };
  case userActionTypes.get_masterdata.REQUEST:
    return {
      ...state,
      loadingMasterData: true,
      master_data: state.master_data,
    };
  case userActionTypes.get_masterdata.SUCCESS:
    // console.log('User Master payload: ', payload);
    // let userLocationList = [];
    // let userLocations = state.userLocations.slice(0);
    // let masterLocations = payload.masterLocation.slice(0);
    // // console.log('userLocations==', userLocations, 'masterLocations==', masterLocations);
    // masterLocations.map((masterLoc) => {
    //   userLocations.find((userLoc) => {
    //     if (userLoc.LocationID === masterLoc.id) {
    //       userLocationList.push(masterLoc);
    //     }

    //   });
    //   return userLocationList;
    // });

    return {
      ...state,
      loadingMasterData: false,
      master_data: payload,
      // userLocationList: userLocationList,
    };
  case userActionTypes.save_appointment.SUCCESS:
    return {
      ...state,
      loading: false,
      appointment_created: true,
    };

  case userActionTypes.get_all_users.SUCCESS:

    return {
      ...state,
      loading: false,
      staffList: payload,
    };

  case userActionTypes.get_users_by_location.SUCCESS:
    return {
      ...state,
      loading: false,
      staffList: payload,
    };
  case userActionTypes.save_staffDetails.REQUEST:
    return {
      ...state,
      loading: true,
      saved_StaffDetails: null,
    };
  case userActionTypes.save_staffDetails.SUCCESS:
  case userActionTypes.save_staffDetails.FAILURE:
    let userInfoDetail = {
      StaffID: payload && payload.data ? payload.data.id : null,
      UserID: payload && payload.data ? payload.data.userID : null,
    };
    return {
      ...state,
      loading: false,
      saved_StaffDetails: payload,
      userInfo: userInfoDetail,
    };
  case userActionTypes.save_user.SUCCESS:
    let activeUserData = payload.data && payload.data.attributes ? payload.data.attributes : payload.data && payload.data.value ? payload.data.value : null;
    activeUserData['id'] = payload.data && payload.data.id ? payload.data.id : payload.data && payload.data.value ? payload.data.value.id : null ;
    return {
      ...state,
      loading: false,
      saved_user: payload,
      activeUser: activeUserData,
      user: payload,
    };
  case userActionTypes.save_user.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case userActionTypes.post_staff_leave.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case userActionTypes.search_patient.SUCCESS:
    return {
      ...state,
      loading: false,
      patients: payload,
    };
  case userActionTypes.get_staffDetailsById.REQUEST:
    return {
      ...state,
      loading: true,
      staffDetails: null,
    };
  case userActionTypes.get_staffDetailsById.SUCCESS:
  case userActionTypes.get_staffDetailsById.FAILURE:
    let userInfoData = {
      StaffID: payload && payload.data ? payload.data.id : null,
      UserID: payload && payload.data ? payload.data.userID : null,
    };
    return {
      ...state,
      loading: false,
      staffDetails: payload,
      userInfo: userInfoData,
    };
  case userActionTypes.get_staffProfileDetails.REQUEST:
    return {
      ...state,
      loading: true,
      staffProfileDetails: null,
    };
  case userActionTypes.get_staffProfileDetails.SUCCESS:
      let userData = payload.data;
      // let userDetails = userData.userInfo && userData.userInfo.length ? userData.userInfo[0] : {};
      let userInfomationData = {        
        StaffID: userData.staffId,
        UserID: userData.userId,
      };
    return {
      ...state,
      loading: false,
      staffProfileDetails: payload,
      userInfo: userInfomationData,
      userMenuShowStatus: true,
    };
  case userActionTypes.get_user_by_id.SUCCESS:
  // console.log('payload...........',payload)
    let userInfo = null;
    let tags = []; //  Filter Insurance by patientId
    if (payload.staffTags) {
      payload.staffTags.filter((allData) => {
        tags.push(allData);
        return tags;
      });
    }

    userInfo = {
      StaffID: payload && Object.keys(payload).length ? payload.id : null,
      UserID: payload && Object.keys(payload).length ? payload.userID : null,
    };
    return {
      ...state,
      loading: false,
      // saving: false,
      activeUser: payload,
      staffTags: tags,
      userInfo: userInfo,
    };

  case userActionTypes.get_master_state_by_countryid.SUCCESS:
    return {
      ...state,
      loading: false,
      masterStateByCountryId: payload,
    };
  case userActionTypes.get_applied_leave_list.REQUEST:
    return {
      ...state,
      loading: true,
      applied_leave_list: null,
    };
  case userActionTypes.get_applied_leave_list.SUCCESS:
    return {
      ...state,
      loading: false,
      applied_leave_list: payload,
    };
  case userActionTypes.get_users.REQUEST:
    return {
      ...state,
      loading: true,
      users_list: null,
    };
  case userActionTypes.get_users.SUCCESS:
    return {
      ...state,
      loading: false,
      users_list: payload,
    };
  case userActionTypes.get_staffsList.REQUEST:
    return {
      ...state,
      loading: true,
      staffs_list: null,
    };
  case userActionTypes.get_staffsList.SUCCESS:
    return {
      ...state,
      loading: false,
      staffs_list: payload,
    };
  case userActionTypes.delete_staffDetails.REQUEST:
    return {
      ...state,
      loading: true,
      deletedStaffDetails: null,
    };
  case userActionTypes.delete_staffDetails.SUCCESS:
    return {
      ...state,
      loading: false,
      deletedStaffDetails: payload,
    };
  case userActionTypes.delete_user.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_user: payload,
    };

  case userActionTypes.delete_appointment.SUCCESS:
    return {
      ...state,
      loading: false,
      appointment_deleted: true,
    };
  case userActionTypes.get_masterCustomLabels.REQUEST:
    return {
      ...state,
      loading: true,
      masterCustomLabelStaff: null,
    };
  case userActionTypes.get_masterCustomLabels.SUCCESS:
  // console.log(payload);
    return {
      ...state,
      loading: false,
      masterCustomLabelStaff: payload,
    };
  case userActionTypes.get_master_tags.REQUEST:
    return {
      ...state,
      loading: true,
      master_data: state.master_data,
    };
  case userActionTypes.get_master_tags.SUCCESS:
    let masterTags = [];
    if (payload && payload.data) {
      payload.data.map((obj, index) => {
        masterTags.push({ id: parseInt(obj.id, 10), value: obj.attributes.value });
        return masterTags;
      });
    }
    return {
      ...state,
      loading: false,
      get_master_tags: masterTags,
      get_original_master_tags: payload.data,
    };
  case userActionTypes.post_user_tag.SUCCESS:
    return {
      ...state,
      saved_user_tag: payload,
      loading: false,
    };
  case userActionTypes.save_availibility_template.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_availibility_template: payload,
    };
  case userActionTypes.save_availibility_template.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case userActionTypes.get_availability_template_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      get_availability_template_by_id: null,
    };
  case userActionTypes.get_availability_template_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      get_availability_template_by_id: payload,
    };
  case userActionTypes.patch_staff_active_status.SUCCESS:
    return {
      ...state,
      staffActiveStatus: payload,
      loading: false,
    };
  case userActionTypes.patch_staff_scheduler_lock.SUCCESS:
  case userActionTypes.patch_staff_lock_status.SUCCESS:
    return {
      ...state,
      staffLockStatus: payload,
      loading: false,
    };
  case userActionTypes.get_user_master_tags.REQUEST:
    return {
      ...state,
      loadingTags: true,
      userMasterTags: null,
    };
  case userActionTypes.get_user_master_tags.SUCCESS:
    return {
      ...state,
      loadingTags: false,
      userMasterTags: payload,
    };
  case userActionTypes.user_menu_show_status.SUCCESS:
    return {
      ...state,
      userMenuShowStatus: payload,
    };
  case userActionTypes.get_office_hours.REQUEST:
    return {
      ...state,
      loading: true,
      getOfficeHours: null,
    };
  case userActionTypes.get_office_hours.SUCCESS:
    return {
      ...state,
      loading: false,
      getOfficeHours: payload,
    };
  case userActionTypes.get_staffLocations.REQUEST:
    return {
      ...state,
      loading: true,
      staffLocationsList: null,
    };
  case userActionTypes.get_staffLocations.SUCCESS:
    return {
      ...state,
      loading: false,
      staffLocationsList: payload,
    };
  case userActionTypes.get_staffPayrollRates.REQUEST:
    return {
      ...state,
      loading: true,
      staffPayrollRates: null,
    };
  case userActionTypes.get_staffPayrollRates.SUCCESS:
    return {
      ...state,
      loading: false,
      staffPayrollRates: payload,
    };
  case userActionTypes.post_staffPayrollRates.REQUEST:
    return {
      ...state,
      loading: true,
      saved_staffPayrollRates: null,
    };
  case userActionTypes.post_staffPayrollRates.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_staffPayrollRates: payload,
    };
  case userActionTypes.get_patient_list.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case userActionTypes.get_patient_list.SUCCESS:
    return {
      ...state,
      patientList: payload,
      loading: false,
    };
    case userActionTypes.Post_Staff_Internal_Notes.REQUEST:
      return {
        ...state,
        loading: true,     
        saved_Notes: null, 
      };
    case userActionTypes.Post_Staff_Internal_Notes.SUCCESS:
      return {
        ...state,
        loading: false,  
        saved_Notes: payload,    
        };
    case userActionTypes.Get_Staff_Internal_Notes.REQUEST:
      return {
        ...state,      
        loading: true,
        StaffInternalNotes: null,
      };
    case userActionTypes.Get_Staff_Internal_Notes.SUCCESS:
      return {
        ...state,
        StaffInternalNotes: payload,
        loading: false,
      };
    case userActionTypes.Delete_Staff_Internal_Notes.REQUEST:
      return {
        ...state,
        loading: true,   
        deleted_Notes: null,   
      };
    case userActionTypes.Delete_Staff_Internal_Notes.SUCCESS:
      return {
        ...state,
        loading: false,      
        deleted_Notes: payload,
        };
    case userActionTypes.get_StaffByTags.REQUEST:
      return {
        ...state,
        loading: true,
        staffs_list_ByTags: null,
      };
    case userActionTypes.get_StaffByTags.SUCCESS:
      return {
        ...state,
        loading: false,
        staffs_list_ByTags: payload,
      };
      case userActionTypes.get_ClientByTags.REQUEST:
        return {
          ...state,
          loading: true,
          clients_list_ByTags: null,
        };
      case userActionTypes.get_ClientByTags.SUCCESS:
        return {
          ...state,
          loading: false,
          clients_list_ByTags: payload,
        };
    case userActionTypes.get_staffTrainingTitleHours.REQUEST:
      return {
        ...state,
        loading: true,
        staffTrainingTitleHours: null,
      };
    case userActionTypes.get_staffTrainingTitleHours.SUCCESS:
      return {
        ...state,
        loading: false,
        staffTrainingTitleHours: payload,
      };
    case userActionTypes.post_staffTrainingTitleHours.REQUEST:
      return {
        ...state,
        loading: true,
        saved_staffTrainingTitleHours: null,
      };
    case userActionTypes.post_staffTrainingTitleHours.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_staffTrainingTitleHours: payload,
      };

    case userActionTypes.get_userRoles.REQUEST:
      return {
        ...state,
        loading: true,
        userRoles: null,
      };
    case userActionTypes.get_userRoles.SUCCESS:
      return {
        ...state,
        loading: false,
        userRoles: payload,
      };
    case userActionTypes.get_appointmentType.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userActionTypes.get_appointmentType.SUCCESS:
      return {
        ...state,
        loading: false,
        appointmentTypeList: payload,
      };
      case userActionTypes.post_resetUserEmail.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userActionTypes.post_resetUserEmail.SUCCESS:
      return {
        ...state,
        loading: false,
        reset_User_Email: payload,
      };
    case userActionTypes.post_checkEmailChangeValidation.REQUEST:
      return {
        ...state, 
        loading: true,
        responseMessage : null,
      };
    case userActionTypes.post_checkEmailChangeValidation.SUCCESS:
      return {
        ...state,
        loading: false,
        responseMessage: payload.message,
      };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/users/reducers/UserReducer.js